import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingVideoAnimation', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: '28-Day Military Workout Plan Based on Your Age',
			size: 'small',
			customStyles: {
				marginLeft: '2rem',
				marginRight: '2rem',
			},
		}),

		LandingVideoAnimation: (): LandingComponentsConfig['LandingVideoAnimation'] => ({
			url: require('@/assets/landing-videos/military-m.mp4'),
			loop: true,
			customStyles: {
				height: '50vh',
			},
		}),

		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
